import { useState } from "react";
import CommentForm from "./CommentForm";
import CommentMainPart from "./comment-helper/CommentMainPart";
import CommentAvatar from "./comment-helper/CommentAvatar";
import { IComment } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import { useGetAllBlogCommentRepliesInfiniteQuery } from "@/api/AppApi/services/blogs";
import { Spinner } from "@/utils/bootstrap";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface props extends IComment {
  blogSlug: string;
  isReply: boolean;
  showCommentForm: boolean;
  selectedCommentToReply: null | number;
  setSelectedCommentToReply: (selectedComment: null | number) => void;
  isMobile: boolean;
}

const Comment: React.FC<props> = ({
  id,
  replies_count,
  user,
  date,
  timestamp_date,
  content,
  dislikes,
  likes,
  replies,
  reaction,
  isReply,
  showCommentForm,
  blogSlug,
  selectedCommentToReply,
  setSelectedCommentToReply,
  isMobile,
}) => {
  const t = useTranslation();
  const [fetchedFirstTime, setFetchedFirstTime] = useState(false);
  const [restReplies, setRestReplies] = useState(
    replies_count! - replies?.length! > 0
      ? replies_count! - replies?.length!
      : 0,
  );

  //? fectch more replies
  const getAllRepliesInfinite = useGetAllBlogCommentRepliesInfiniteQuery({
    blogSlug,
    commentID: id,
    enabled: fetchedFirstTime,
    params: {},
  });
  const allRepliesPages = getAllRepliesInfinite?.data?.pages;
  const { per_page } = allRepliesPages?.[0]?.result?.meta ?? {};
  const handleFetchReplies = () => {
    if (!fetchedFirstTime) {
      setFetchedFirstTime(true);
      return;
    }
    setRestReplies((restReplies) =>
      restReplies - per_page! > 0 ? restReplies - per_page! : 0,
    );
    getAllRepliesInfinite?.fetchNextPage();
  };
  const repliesToRender = !getAllRepliesInfinite?.isFetched
    ? [{ data: replies! }]
    : allRepliesPages?.map((page) => {
        return { data: page?.result?.data };
      });
  const mClass = isMobile ? "-mobile" : "";
  const showSeeMore =
    !isReply &&
    (!fetchedFirstTime
      ? replies_count! > replies?.length!
      : getAllRepliesInfinite && getAllRepliesInfinite?.hasNextPage!);
  return (
    <div className={`blog-comment${mClass} ${isReply ? "comment-replay" : ""}`}>
      <CommentAvatar name={user?.name} />
      <div className="content">
        <CommentMainPart
          blogSlug={blogSlug}
          commentId={id}
          selectedCommentToReply={selectedCommentToReply}
          setSelectedCommentToReply={setSelectedCommentToReply}
          likes={likes}
          disLikes={dislikes}
          reaction={reaction}
          name={user?.name}
          date={date}
          timestamp_date={timestamp_date}
          discription={content}
          isReply={isReply}
        />
        {showCommentForm && (
          <CommentForm
            commentID={id}
            blogSlug={blogSlug}
            isReply
            callBack={() => {
              getAllRepliesInfinite?.refetch();
              setFetchedFirstTime(true);
            }}
          />
        )}
        {repliesToRender &&
          repliesToRender?.map((data) =>
            data?.data?.map((reply) => (
              <Comment
                selectedCommentToReply={selectedCommentToReply}
                setSelectedCommentToReply={setSelectedCommentToReply}
                key={"commentReply" + blogSlug + reply?.id}
                blogSlug={blogSlug}
                isReply={true}
                showCommentForm={false}
                id={reply?.id}
                content={reply?.content}
                user={reply?.user}
                date={reply?.date}
                timestamp_date={reply?.timestamp_date}
                dislikes={reply?.dislikes}
                likes={reply?.likes}
                reaction={reply?.reaction}
                isMobile={isMobile}
              />
            )),
          )}
        {showSeeMore && (
          <div
            onClick={handleFetchReplies}
            className={`show-more-replies${mClass}`}
          >
            {t.show_more_replies + ` (${restReplies})`}
          </div>
        )}
        {!isReply && getAllRepliesInfinite.isFetching && (
          <div className="w-100 d-flex justify-content-center">
            <Spinner className="comment-spinner" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Comment;
